// extracted by mini-css-extract-plugin
export default {"enabledContainer":"src-pages-SalesChannelProductsConfig-SalesChannelProductAlias-EditPage-SEOSetting-css-module__enabledContainer--uF89C"};